var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-sm mt-10 1024:mt-20 mb-2"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }